/**
 * Checks that the section is available by checking the route
 * name against a list of available sections.
 */
export const buildSupervisorSectionIsAvailableGuard =
    store => (to, from, next) => {
        const availableSections = store.getters["supervisor/availableSections"]
        if (availableSections.includes(to.name)) {
            next()
        } else {
            next({ name: "not-found" })
        }
    }

/**
 * Checks that the desired request type is available.
 */
export const buildSupervisorRequestIsAvailableGuard =
    store => (to, from, next) => {
        const availableRequests =
            store.getters["supervisor/availableRequestLinks"]

        if (availableRequests.includes(to.params.requestType)) {
            next()
        } else {
            next({ name: "not-found" })
        }
    }

export const buildSupervisorHasGuard = (store, prop) => (to, from, next) => {
    if (store.state.supervisor.panel[prop]) {
        next()
    } else {
        next({ name: "not-found" })
    }
}
